import { useEffect, useState } from 'react';
import { getTrainsInfo } from '../../../services/customer/ticketBookingServices';

function useRidesCarriagesInfo({ bookingData, seatFormation }) {
  const [chosenRides, setChosenRides] = useState({
    departure: {},
    return: {},
    statement: {},
  });

  useEffect(() => {
    const fetchData = async () => {
      const res = await getTrainsInfo({
        departureRideId: bookingData?.departure?.id,
        startStationCode: bookingData?.departure?.startStation?.code,
        endStationCode: bookingData?.departure?.endStation?.code,
        returnWay: Boolean(bookingData?.return?.id),
        ...(bookingData?.return?.id && { returnRideId: bookingData?.return?.id }),
        selectionTypeId:
            bookingData?.departure?.availableSeatsGroups?.[0]?.availableNumberOfSeats > 0 ? 2 : 1,
      });
      if (res?.departure) {
        res.departure.carriages = res
          .departure.carriages?.sort((a, b) => a.order_number - b.order_number);
      }

      if (res?.return) {
        res.return.carriages = res
          .return.carriages?.sort((a, b) => a.order_number - b.order_number);
      }
      setChosenRides(res);
    };
    if (seatFormation === 'select') {
      fetchData();
    }
  }, []);

  return chosenRides;
}

export default useRidesCarriagesInfo;
